import React from 'react';

import Button from '../inputs/Button';
import Textbox from '../inputs/Textbox';
import classnames from 'classnames/bind';
import Chevron from '../../svgs/chevron';
import styles from './styles.module.scss';
const bStyles = classnames.bind(styles);

export class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editing: false,
      currentName: this.props.section,
      openPageOptions: false
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.section !== this.props.section) {
      this.setState({ currentName: this.props.section });
    }
  }

  render() {
    let sectionJSX = <></>;
    let rightButtons = this.props.rightButtons || [];
    if (!Array.isArray(rightButtons)) rightButtons = [rightButtons];
    const buttonJSX = (
      <div className={styles.buttons}>
        {this.props.right || <></>}
        {rightButtons.map((b, i) => {
          if ('visible' in b && !b.visible)
            return <React.Fragment key={i}></React.Fragment>;
          const className = b.className;
          delete b.visible;
          delete b.className;
          return (
            <Button
              testID={b.text}
              key={i}
              className={[className, styles.headerButton]}
              {...b}
            />
          );
        })}
      </div>
    );
    const dropdownJSX = (
      <div className={styles.pageActions}>
        <h2
          onClick={() =>
            this.setState(state => {
              return {
                openPageOptions: !state.openPageOptions
              };
            })
          }
        >
          Page Actions
          <Chevron
            className={styles.chevron}
            style={{
              transform: this.state.openPageOptions
                ? 'rotate(90deg)'
                : 'rotate(-90deg)'
            }}
          />
        </h2>
        {this.state.openPageOptions && (
          <div className={styles.dropdown}>
            {this.props?.pageActionOptions
              ?.filter(option => option.visible)
              .map((option, i) => (
                <div
                  key={i}
                  onClick={() => {
                    !option.disabled && option.onClick();
                    this.setState({ openPageOptions: false });
                  }}
                  className={bStyles('dropdownOption', option.color)}
                >
                  {option.label}
                </div>
              ))}
          </div>
        )}
      </div>
    );

    if (this.props.section) {
      if (this.state.editing) {
        sectionJSX = (
          <div className={styles.section}>
            <Textbox
              placeholder={this.props.hasNoName ? '' : this.props.section}
              className={styles.input}
              currentValue={this.state.currentName}
              onChange={v => this.setState({ currentName: v })}
              onBlur={() =>
                this.setState({ editing: false, showLengthWarning: false })
              }
              escape={() => this.setState({ editing: false })}
              enter={() => {
                if (this.state.currentName.trim()?.length < 4)
                  this.setState({ showLengthWarning: true });
                else {
                  if (
                    this.state.currentName !== this.props.section &&
                    this.state.currentName?.trim().length
                  ) {
                    this.props.editName(this.state.currentName);
                    this.setState({ showLengthWarning: false });
                  } else this.setState({ currentName: this.props.section });
                  this.setState({ editing: false });
                }
              }}
              autoFocus
            />
            {this.state.showLengthWarning ? (
              <div className={styles.lengthWarning}>
                Must be at least 4 characters
              </div>
            ) : null}
          </div>
        );
      } else {
        sectionJSX = (
          <div className={styles.section}>
            <div className={styles.sectionName} title={this.props.section}>
              {this.props.section}
            </div>
            {this.props.editName && !this.props.readOnly && (
              <div
                className={styles.edit}
                onClick={() =>
                  this.setState({
                    editing: true,
                    currentName: this.props.hasNoName
                      ? ''
                      : this.state.currentName
                  })
                }
              >
                <img
                  src={require('../../assets/images/editName.png')}
                  alt="Edit Name"
                />
              </div>
            )}
          </div>
        );
      }
    }
    return (
      <header
        className={bStyles({
          header: true,
          noCenter: !this.props.center,
          hideShadow: this.props.hideBoxShadow ?? false
        })}
      >
        <div className={styles.headerInfo}>
          {this.props.clickBack && (
            <div
              className={bStyles(styles.backButton, {
                unsavedChanges: this.props.needsSaved
              })}
              onClick={this.props.clickBack}
            >
              <Chevron className={styles.backChev} fill="currentColor" />
            </div>
          )}
          <div className={styles.title}>
            <div>{this.props.title}</div>
            {sectionJSX}
          </div>
        </div>
        {this.props.center && (
          <div className={styles.center}>{this.props.center}</div>
        )}
        {this.props.right ||
        (this.props.rightButtons && !this.props.pageActionOptions)
          ? buttonJSX
          : this.props.pageActionOptions?.length
            ? dropdownJSX
            : undefined}
      </header>
    );
  }
}
export default Header;
